import type {Expense} from './types';

export type DueShare={name:string;amount:number;settled:boolean};

export function expenseDueShares(expense:Expense):DueShare[]{
 const people=Array.from(new Set((expense.splitWith||[]).filter(Boolean)));
 if(!people.length)return [];
 const total=Math.round(Number(expense.amountTwd)||0);
 const base=Math.floor(total/people.length);
 const remainder=total-base*people.length;
 return people.map((name,index)=>({name,amount:base+(index<remainder?1:0),settled:(expense.settledBy||[]).includes(name)})).filter(share=>share.name!==expense.paidBy);
}

export function settlementSummary(expenses:Expense[]){
 const balances=new Map<string,number>();
 let outstanding=0;let settled=0;
 for(const expense of expenses){
  for(const share of expenseDueShares(expense)){
   if(share.settled){settled+=share.amount;continue;}
   outstanding+=share.amount;
   balances.set(expense.paidBy,(balances.get(expense.paidBy)||0)+share.amount);
   balances.set(share.name,(balances.get(share.name)||0)-share.amount);
  }
 }
 return {outstanding,settled,balances:Array.from(balances,([name,balance])=>({name,balance})).filter(row=>row.balance!==0)};
}
